
function Loader({label}) {
  var label = label || 'Loading...';
  return (
    <span className="loader">
        <i className="fa fa-circle-notch fa-spin"></i> {label}
    </span>
  );
}

export default Loader;
